import { CustomBoxV2 } from "components";
import { ShortGameIcon } from "pages/internal-dashboard/icons";
import React from "react";

export function ShortGame({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#FFA84A"
      title="Short Game"
      userCount={data?.total || 0}
      boxData={{
        label: "Short Game",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: ShortGameIcon,
      }}
      percentages={percentages}
    />
  );
}
